import actions from './actions';
import mutations from './mutations';
import { BrandKitState } from './types';

const state: BrandKitState = {
  brandKits: [],
  selectedBrandKit: null,
  isLoading: false,
  isLoaded: false
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
